export default __webpack_public_path__ + "static/media/clock.bf057943.JPG";